import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@mlb/react-patterns/v4/components/Skeleton/skeleton';
import {
    HighlightPlaylistWrapper,
    HighlightVideoPlayerWrapper,
    HighlightVideoHeadlineWrapper,
    HighlightCardListWrapper,
    HighlightVideoPlayerSkeleton
} from '../HighlightsPlaylist.style';

export const HighlightsPlaylistSkeleton = ({
    extendedDisplay = false
}) => {
    return (
        <HighlightPlaylistWrapper $extendedDisplay={extendedDisplay}>
            <HighlightVideoPlayerWrapper>
                <HighlightVideoPlayerSkeleton margin='0' borderRadius='0' height='unset' />
                <HighlightVideoHeadlineWrapper>
                    <Skeleton height='24px' width='80%' />
                    <div>
                        <Skeleton height='21px' />
                        <Skeleton height='21px' width='30%' />
                    </div>
                </HighlightVideoHeadlineWrapper>
            </HighlightVideoPlayerWrapper>
            <HighlightCardListWrapper>
                <Skeleton height='85px' margin='0' count={5} />
            </HighlightCardListWrapper>
        </HighlightPlaylistWrapper>
    );
};

HighlightsPlaylistSkeleton.propTypes = {
    extendedDisplay: PropTypes.bool
};

export default HighlightsPlaylistSkeleton;
